import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { UserProfileComponent } from 'src/app/shared/components/user-profile/user-profile.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { UserType } from 'src/app/shared/constants/user-type.enum';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../../../providers/storage.service';

@Component({
  selector: 'sm-latest-messages',
  templateUrl: './latest-messages.component.html',
  styleUrls: ['./latest-messages.component.scss']
})
export class LatestMessagesComponent implements OnInit, OnDestroy {

  messageLIst: any[] = [];
  count: number = 0
  imageThumbUrl: string = environment.profileImageBaseUrl;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "message",
      columnProperty: "message"
    }
  ];
  private _apiSubscription: Subscription;
  chatThreads:any = []
  constructor(private _storageService: StorageService,private _apiService: ApiService, private _dialog: MatDialog, private router: Router, private route: ActivatedRoute) {
    // this.messageLIst = USERS_LIST;

    this.messageLIst = [
      
      // {
      //   "name": "Rajesh Sharma",
      //   "message": "I've been eagerly following your amazing work and I would be absolutely thrilled to book an appointment with you. Your talent is truly extraordinary and I can't wait to experience it firsthand. Could you please let me know your availability? I'm flexible with dates and times. Thank you so much!",
      //   "imageUrl": "https://randomuser.me/api/portraits/men/1.jpg"
      // },
      // {
      //   "name": "Nayan Singh",
      //   "message": "I wanted to take a moment to express how much I loved the makeup you did for me last time! It truly exceeded my expectations and I received so many compliments. I can't wait to book another appointment with you. Your talent and attention to detail are truly remarkable. Looking forward to our next session!",
      //   "imageUrl": "https://randomuser.me/api/portraits/men/4.jpg"
      // },
      // {
      //   "name": "Sneha Patel",
      //   "message": "I hope you can understand that I'm facing a family emergency today. It's a situation that requires my immediate attention and support. I deeply regret any inconvenience this may cause to the team and the clients. Rest assured, I will do my best to handle the situation and return to work as soon as I can. Thank you for your understanding and support.",
      //   "imageUrl": "https://randomuser.me/api/portraits/women/2.jpg"
      // },
      // {
      //   "name": "Amit Kumar",
      //   "message": "I've been searching for a makeup artist with your level of skill and expertise. Your work truly speaks for itself. I would be honored to book an appointment with you. Could you please let me know when you have availability? I'm eager to have you work your magic!",
      //   "imageUrl": "https://randomuser.me/api/portraits/men/3.jpg"
      // },
      // {
      //   "name": "Sachin Bansal",
      //   "message": "I just wanted to extend my heartfelt thanks for making me feel so special on my big day. Your skill and creativity in makeup artistry are truly unmatched. The way you understood my vision and brought it to life was nothing short of magical. You played a significant role in making my day extra memorable. Thank you once again for your exceptional work!",
      //   "imageUrl": "https://randomuser.me/api/portraits/women/5.jpg"
      // },
     
    ]
    


    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_ALL_ENTITY_DETAILS_RESULT){
        console.log(resData);
        resData.result.length = 10
        this.messageLIst = resData.result ? resData.result : [];
        console.log( this.messageLIst);
        this.messageLIst.forEach((item )=> {
          if(item.addressInfo && item.addressInfo!= null){
            item.addressInfo = (JSON.parse(item.addressInfo)).address_line
          }
          if(item.isActive == '2' ||item.isActive == '3' ){
            item.isActive = 'Deleted'
          }
          if(item.isActive == '1'){
            item.isActive = 'Active'
          }
          if(item.isActive == '0'){
            item.isActive = 'Deactive'
          }
         
        })
            console.log( this.messageLIst);
        
      }

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID){
        this.chatThreads = []
        if(resData.result){

          resData.result.forEach((element:any) => {
            if(element.senderInfo && element.receiverInfo){
              if(element.senderInfo && typeof element.senderInfo == 'string'){
                element.senderInfo = JSON.parse(element.senderInfo)
              }
              if(element.receiverInfo && typeof element.receiverInfo == 'string'){
                element.receiverInfo = JSON.parse(element.receiverInfo)
              }
             
              this.chatThreads.push(element)
              
            }
          });
          
        }
        console.log(this.chatThreads);
        
      }
     
    });
  }

  ngOnInit(): void {
    this._apiService.getMessagesByID()
  }

  viewProfile(profileData: any){
    this._dialog.open(UserProfileComponent, {
      data: profileData,
      maxWidth: 370,
      panelClass: 'user-profile-dialog'
    });
  }
  viewBusiness(value: any){
    console.log("click");
    this._storageService.setValueInAppStorage('specificEntityHash', value.hashId)
    this._storageService.setValueInAppStorage('specificEntityName', value.name)
    this.router.navigate(['users','entity-business'], {relativeTo: this.route})
    
  }
  seeallmsgs(){
    this.router.navigate(['messages'])
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

}
